import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    background: '#dddddd',
    height: 50,
    margin: 16,
    marginLeft: 0
  },
  content: {
    textAlign: 'center',
    paddingTop: 8
  },
  danger: {
    color: 'red'
  },
  count: {
    fontSize: 24,
    fontWeight: 600,
    marginRight: 4
  },
  label: {
    fontWeight: 600
  }
}));

const DashboardCountBox = (props) => {
  const classes = useStyles();
  const { count, isDanger = false, label } = props;

  return (
    <React.Fragment>
      <div className={classes.container}>
        <div
          className={`${classes.content}  ${isDanger ? classes.danger : ''}`}
        >
          <span className={classes.count}> {count}</span>
          <span className={classes.label}> {label}</span>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DashboardCountBox;
